var _defs, _use, _use2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNorthArrowAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / north_arrow_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-2.48949813e-15%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082CD",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00558C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.0899257%",
    y1: "56.6238153%",
    x2: "100%",
    y2: "56.6238153%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C",
    stopOpacity: 0.2,
    offset: "48.4442562%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.320995411,
    offset: "50.4832216%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "32.5 -2.42382503e-13 0 73.25 0 77 32.5 64.75 65 77 65 73.25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.05,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.9996709%",
    y1: "-11.5357919%",
    x2: "128.223374%",
    y2: "239.056853%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8FF",
    stopOpacity: 0.05,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F448C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-6",
    points: "32.5 -2.42382503e-13 0 73.25 0 77 32.5 64.75 65 77 65 73.25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-north_arrow_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    transform: "translate(13.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation---Fill"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#00B0F4",
    xlinkHref: "#path-3"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-2)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation---Border",
    strokeLinejoin: "square"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-4)",
    strokeWidth: 2,
    d: "M32.5,2.46572961 L64,73.4618835 L64,75.5543997 L32.5,63.6813228 L1,75.5543997 L1,73.4618835 L32.5,2.46572961 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-5)",
    strokeWidth: 1,
    d: "M32.5,1.2328648 L64.5,73.3559417 L64.5,76.2771999 L32.5,64.2156614 L0.5,76.2771999 L0.5,73.3559417 L32.5,1.2328648 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthArrowAppTile);
export default __webpack_public_path__ + "static/media/north_arrow_app_tile.64a6af01df31a3f715c24e2a54897c1c.svg";
export { ForwardRef as ReactComponent };